import React, { useState, useEffect } from "react";
import "./Suggestion.scss"; // Make sure to import your CSS file
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, FormCheck, Row } from "react-bootstrap";
import { Formik } from "formik";
import { OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { CreditCardIcon } from "../../../../assets";
import { CustomCard } from "../../CustomCard";

export const SuggestionCard = ({
  data,
  selectedId,
  isSelected,
  handleDeleteShow,
  dispatch,
}) => {
  const {
    service_pro_sgstn_id,
    user_profile_id,
    provider_name,
    client_phone_nbr,
    provider_phone_nbr,
    addr_street1,
    iso_city_id,
    addr_zipcode,
    addr_state,
    iso_cntry_id,
    sys_active_yn,
    user_email,
    user_first_name,
    user_last_name,
  } = data;

  const { refsdata } = useSelector((state) => state.refstypes);

  return (
    <Formik
      initialValues={{
        paySelected: false,
      }}
      onSubmit={(values) => {}}
    >
      {({ touched, errors, values, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <CustomCard className="facility patient-card">
            <div
              className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
              style={{ borderBottom: "1px solid #E7E7E9" }}
            >
              <div className="d-flex align-items-center justify-content-center gap-2">
                <div>
                  <h6 className="card-title mb-0">{provider_name}</h6>
                  <small>#{service_pro_sgstn_id}</small>
                </div>
              </div>
              <div className="icons">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">Delete Suggestion</Tooltip>
                  }
                >
                  <Icon
                    onClick={() =>
                      handleDeleteShow(
                        data.service_pro_sgstn_id,
                        data.provider_name + " #"
                      )
                    }
                    icon="mingcute:delete-fill"
                    color="red"
                    className="cursor-pointer"
                  />
                </OverlayTrigger>
              </div>
            </div>

            <div className="row gap-y-[18px]">
              <div className="col-6">
                <small>Client Name:</small>
                <p className="truncate mb-0">
                  {user_first_name || " " || user_last_name}
                </p>
              </div>
              <div className="col-6">
                <small>Client Phone:</small>
                <p className="truncate mb-0">{client_phone_nbr}</p>
              </div>
              <div className="col-6">
                <small>Client Email</small>
                <p className="truncate mb-0">{user_email}</p>
              </div>
              <div className="col-6">
                <small>Provider to onboard:</small>
                <p className="truncate mb-0">{provider_name}</p>
              </div>
              <div className="col-6">
                <small>Provider #:</small>
                <p className="truncate mb-0">{provider_phone_nbr}</p>
              </div>
              <div className="col-6">
                <small>Address</small>
                <p className="truncate mb-0">{addr_street1}</p>
              </div>
              <div className="col-6">
                <small>City</small>
                <p className="truncate mb-0"> {iso_city_id}</p>
              </div>
            </div>
          </CustomCard>
        </Form>
      )}
    </Formik>
  );
};
